import script from "./OtherReserves.vue?vue&type=script&setup=true&lang=js"
export * from "./OtherReserves.vue?vue&type=script&setup=true&lang=js"

import "./OtherReserves.vue?vue&type=style&index=0&id=f5404788&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5404788"]])

export default __exports__